/* eslint-disable no-nested-ternary */
import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Link, { LinkProps } from '@material-ui/core/Link';
import ListItem from '@material-ui/core/ListItem';
import Collapse from '@material-ui/core/Collapse';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link as RouterLink, useLocation, Route, MemoryRouter } from 'react-router-dom';
import { Omit } from '@material-ui/types';

interface ListItemLinkProps extends LinkProps {
  to: string;
  open?: boolean;
}

const breadcrumbNameMap: { [key: string]: string } = {
  '/dashboard': 'Dashboard',
  '/pedidos': 'Pedidos',
  '/pedidos/novo': 'Novo',
  '/pedidos/consultar': 'Consultar',
  '/prepedidos': 'Pré-Pedidos',
  '/prepedidos/consultar': 'Consultar',
  '/clientes': 'Clientes',
  '/clientes/novo': 'Novo',
  '/clientes/consultar': 'Consultar',
  '/relatorios': 'Relatórios',
  '/aprovacao': 'Aprovação',
  '/relatorios/pedidos': 'Pedidos',
  '/relatorios/pedidos/RVPE461': 'RVPE461',
  '/relatorios/pedidos/RVPE620': 'RVPE620',
  '/relatorios/pedidos/RVPE571': 'RVPE571',
  '/relatorios/pedidos/RVPE558': 'RVPE558',
  '/relatorios/faturamento': 'Faturamento',
  '/relatorios/estoque': 'Estoque',
  '/relatorios/cadastros': 'Cadastros',
  '/relatorios/financeiro': 'Financeiro',
  '/relatorios/faturamento/RFNF520': 'RFNF520',
  '/relatorios/estoque/SECE500': 'SECE500',
  '/relatorios/estoque/PANT001': 'PANT001',
  '/relatorios/cadastros/DSCF208': 'DSCF208',
  '/relatorios/financeiro/FRCR898': 'FRCR898',
  '/usuario': 'Usuário',
  '/usuario/perfil': 'Perfil'
};

function ListItemLink(props: Omit<ListItemLinkProps, 'ref'>) {
  const { to, open, ...other } = props;
  const primary = breadcrumbNameMap[to];

  return (
    <li>
      <ListItem button component={RouterLink} to={to} {...other}>
        <ListItemText primary={primary} />
        {open != null ? open ? <ExpandLess /> : <ExpandMore /> : null}
      </ListItem>
    </li>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: 360,
    },
    lists: {
      backgroundColor: theme.palette.background.paper,
      marginTop: theme.spacing(1),
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
  }),
);

interface LinkRouterProps extends LinkProps {
  to: string;
  replace?: boolean;
}

const LinkRouter = (props: LinkRouterProps) => <Link {...props} component={RouterLink as any} />;

export function RouterNavigation() {
  let location = useLocation();
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <MemoryRouter initialEntries={['/']} initialIndex={0}>
      <div className={classes.root}>
        <Route>
          {() => {
            const pathnames = location.pathname.replace("clientes/ga/pedidos-force/", "").split('/').filter((x) => x);

            return (
              <Breadcrumbs aria-label="breadcrumb">
                <div>
                  Início
                </div>
                {pathnames.map((value, index) => {
                  const last = index === pathnames.length - 1;
                  const to = `/${pathnames.slice(0, index + 1).join('/')}`;

                  return last ? (
                    <Typography color="textPrimary" key={to}>
                      {breadcrumbNameMap[to]}
                    </Typography>
                  ) : (
                    <div key={to}>
                      {breadcrumbNameMap[to]}
                    </div>
                  );
                })}
              </Breadcrumbs>
            );
          }}
        </Route>
      </div>
    </MemoryRouter>
  );
}
